/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { NineSlicePlane, Texture } from 'pixi.js-legacy';

/**
 * Extends teh PIXI.NineSlicePlane and adds in culling. This class works well for dynamically changing ninesliceplanes
 */
export class FancyNineSlicePlane extends NineSlicePlane {
	public active = false;
	public override visible = false;
	/**
	 * @param {PIXI.Texture} texture Texture for this NineSlicePlane
	 * @param {number} leftWidth size of the left vertical bar (A)
	 * @param {number} topHeight size of the top horizontal bar (C)
	 * @param {number} rightWidth size of the right vertical bar (B)
	 * @param {number} bottomHeight size of the bottom horizontal bar (D)
	 */
	constructor(
		texture: Texture,
		leftWidth?: number,
		topHeight?: number,
		rightWidth?: number,
		bottomHeight?: number
	) {
		super(texture, leftWidth, topHeight, rightWidth, bottomHeight);
	}
	/**
	 * Renders the object using the WebGL renderer
	 * @param renderSession
	 */
	public override _render(renderSession) {
		super._render(renderSession);
	}
	/**
	 * Renders the object using the Canvas renderer
	 * @param renderSession
	 */
	public override _renderCanvas(renderSession) {
		super._renderCanvas(renderSession);
	}
	/**
	 * Update the transformation matrix on this object and all children. May need to optimize this.
	 */
	public override updateTransform() {
		if (this.visible && this.renderable) {
			super.updateTransform();
		}
	}
	/**
	 * Destroy me
	 */
	public override destroy(options?) {
		super.destroy(options);
	}
}
